import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { VideoItemComponent } from 'src/app/@core/models/item-component';
import { MatDialog } from '@angular/material/dialog';
import { GalleryDialogComponent } from '../gallery-dialog/gallery-dialog.component';

@Component({
  selector: 'app-editor-component-video-config',
  templateUrl: 'video-config.component.html'
})
export class EditorVideoConfigComponent implements OnInit, OnChanges {
  @Input() item: VideoItemComponent;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  showVideo = true;

  constructor(
    public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.initItem();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initItem();
  }

  initItem(): void {
    if (this.item) {
      const allowNextVal = this.item.allowNext !== undefined ? this.item.allowNext : (this.item as any).allow_next;
      if (allowNextVal !== undefined && allowNextVal !== null) {
        this.item.allowNext = allowNextVal === true || String(allowNextVal) === 'true' || Number(allowNextVal) === 1;
      } else {
        this.item.allowNext = false;
      }

      if (this.item.showVideoControl === undefined || this.item.showVideoControl === null) {
        this.item.showVideoControl = true;
      } else {
        this.item.showVideoControl = this.item.showVideoControl === true || String(this.item.showVideoControl) === 'true' || Number(this.item.showVideoControl) === 1;
      }

      this.sanitizeSourcePath();
    }
  }

  setAlign(element: any, align: string) {
    element.align = align;
  }

  emitSendEvent(event?: any) {
    this.sanitizeSourcePath();
    this.sendEvent.emit(event);
  }

  openGallery(): void {
    const dialogRef = this.dialog.open(GalleryDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed: result', result);
      this.item.source_path = result.url;
      if (result.url.includes('cloudinary')) {
        this.item.poster = result.url.split('.mp4').join('.webp');
      }
    });
  }

  videoChanged() {
    this.sanitizeSourcePath();
    this.showVideo = false;
    setTimeout(() => {
      this.showVideo = true;
    }, 500);
  }

  sanitizeSourcePath() {
    if (!this.item || !this.item.source_path) {
      return;
    }
    if (this.item.source === 'vimeo') {
      this.item.source_path = this.cleanVimeoUrl(this.item.source_path);
    } else if (this.item.source === 'youtube') {
      this.item.source_path = this.cleanYoutubeUrl(this.item.source_path);
    } else if (typeof this.item.source_path === 'string') {
      this.item.source_path = this.item.source_path.replace(/<[^>]*>?/gm, '').trim();
    }
  }

  cleanVimeoUrl(url: string): string {
    if (!url) return '';
    const srcMatch = url.match(/src=["']([^"']+)["']/i);
    const target = srcMatch ? srcMatch[1] : url;
    const vimeoRegex = /(?:https?:)?\/\/(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)/i;
    const match = target.match(vimeoRegex);
    if (match && match[3]) {
      const hashMatch = target.match(/[?&]h=([a-zA-Z0-9]+)/i);
      if (hashMatch && hashMatch[1]) {
        return `https://player.vimeo.com/video/${match[3]}?h=${hashMatch[1]}`;
      }
      return `https://player.vimeo.com/video/${match[3]}`;
    }
    if (/^\d+$/.test(target.trim())) {
      return `https://player.vimeo.com/video/${target.trim()}`;
    }
    return target.replace(/<[^>]*>?/gm, '').trim();
  }

  cleanYoutubeUrl(url: string): string {
    if (!url) return '';
    const srcMatch = url.match(/src=["']([^"']+)["']/i);
    const target = srcMatch ? srcMatch[1] : url;
    const ytRegex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = target.match(ytRegex);
    if (match && match[2] && match[2].length === 11) {
      return `https://www.youtube.com/watch?v=${match[2]}`;
    }
    if (/^[a-zA-Z0-9_-]{11}$/.test(target.trim())) {
      return `https://www.youtube.com/watch?v=${target.trim()}`;
    }
    return target.replace(/<[^>]*>?/gm, '').trim();
  }
}
